module.exports = __webpack_public_path__ + "img/loadgif.24388114.gif";